import { Dispatch, SetStateAction, useRef, useState } from 'react';

import { Icon as SystemIcon } from 'inpock-ui-react';
import { colors } from 'inpock-ui-react/dist/src/color';
import CSS from 'csstype';

import { Icon } from '@/components';

import * as S from './styled';

interface SearchInputProps {
  clearable?: boolean;
  disabled?: boolean;
  placeholder?: string;
  value: string;
  setValue: Dispatch<SetStateAction<string>>;
  onBlur?: () => void;
  onFocus?: () => void;
  sx?: CSS.Properties;
}

export function SearchInput({ clearable = true, ...props }: SearchInputProps) {
  const [isFocus, setIsFocus] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  const clear = () => {
    props.setValue('');
    focus();
  };
  const focus = () => {
    inputRef.current?.focus();
  };
  const onBlur = () => {
    setIsFocus(false);
    props.onBlur && props.onBlur();
  };
  const onFocus = () => {
    setIsFocus(true);
    props.onFocus && props.onFocus();
  };

  return (
    <div className="inpock-form-item mb-2 input-wrapper">
      <div className="input-area-wrapper">
        <div className="input-area">
          <div className="input-box" style={{ position: 'relative' }}>
            <input
              ref={inputRef}
              type="text"
              value={props.value}
              onBlur={onBlur}
              onFocus={onFocus}
              onChange={(e) => props.setValue(e.target.value)}
              placeholder={props.placeholder}
              disabled={props.disabled}
              style={{
                ...props.sx,
                border: isFocus ? `1px solid ${colors.orange400}` : undefined,
              }}
            />
            <S.SearchIconWrapper showClearable={Boolean(props.value !== '' && clearable)}>
              <Icon icon="Search" size={24} color={isFocus ? colors.orange : colors.gray500} />
            </S.SearchIconWrapper>
            {clearable && props.value && (
              <S.ClearIconWrapper onClick={clear}>
                <SystemIcon useDefaultPadding={false} size={24} color={'white'} icon="Clear" />
              </S.ClearIconWrapper>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
